/**
 * Scene Registry
 *
 * All scenes are registered here for the scene engine.
 */

import { registerScene } from '@/lib/scene';
import { entrance } from './entrance';
import { home } from './home';
import { music } from './music';
import { drip } from './drip';
import { more } from './more';
import { goDeeper } from './go-deeper';
import { relicBunker } from './relic-bunker';

export function initializeScenes(): void {
  registerScene(entrance);
  registerScene(home);
  registerScene(music);
  registerScene(drip);
  registerScene(more);
  registerScene(goDeeper);
  registerScene(relicBunker);
}

export { entrance } from './entrance';
export { home } from './home';
